<div class="landing-container">
  <div class="landing-container-image">
    <img [src]="getLandingImage" />
  </div>
  <div class="landing-container-image-mobile">
    <img [src]="getLandingImageMobile" />
  </div>
  <div class="landing-container-header">
    <div class="back-icon-button">
      <img
        *ngIf="toggleLoginMenu || isInLogin"
        (click)="toggleClickBack()"
        [src]="getBackIcon"
        alt="back"
      />
    </div>
    <div class="options-right">
      <div class="lang-options">
        <span
          *ngFor="let lang of translate.getLangs()"
          [ngClass]="isActiveLang === lang ? 'active' : ''"
          (click)="changeLang(lang)"
        >
          {{ lang }}
        </span>
      </div>
      <div class="logo-image">
        <img [src]="getLogoImage" />
      </div>
    </div>
  </div>
  <div class="landing-container-text">
    <div class="landing-subtitle">{{ "landing.subtitle" | translate }}</div>
    <div class="landing-title">{{ "landing.title" | translate }}</div>
  </div>

  <div
    *ngIf="!toggleLoginMenu && !isInLogin && !isPwdRecov"
    class="landing-container-buttons right"
  >
    <cowing-button
      [label]="'landing.join-us' | translate"
      [type]="EButtonType.Primary"
      [iconShow]="true"
      [iconName]="'arrowRight'"
      (event)="toggleRegisterMenu($event)"
    >
    </cowing-button>
    <cowing-button
      [label]="'landing.is-user' | translate"
      [type]="EButtonType.Secondary"
      (event)="toLogin($event)"
    >
    </cowing-button>
  </div>
  <div
    *ngIf="toggleLoginMenu && !toggleCompanyCoworkingMenu && !isInLogin && !isPwdRecov"
    class="landing-container-buttons right"
  >
    <cowing-button
      [label]="'landing.register-coworking' | translate"
      [iconShow]="true"
      [iconName]="'arrowRight'"
      (event)="toCoworkingRegister($event)"
    >
    </cowing-button>
    <cowing-button
      [label]="'landing.register-company' | translate"
      [iconShow]="true"
      [iconName]="'arrowRight'"
      (event)="toggleCompanyCoworkingRegister($event)"
    >
    </cowing-button>
  </div>
  <div
    *ngIf="toggleLoginMenu && toggleCompanyCoworkingMenu && !isInLogin && !isPwdRecov"
    class="landing-container-buttons right"
  >
    <cowing-button
      [label]="'landing.register-company-coworking' | translate"
      [iconShow]="true"
      [iconName]="'arrowRight'"
      (event)="toCompanyCoworkingRegister($event)"
    >
    </cowing-button>
    <cowing-button
      [label]="'landing.register-only-company' | translate"
      [iconShow]="true"
      [iconName]="'arrowRight'"
      (event)="toCompanyRegister($event)"
    >
    </cowing-button>
  </div>
  <div *ngIf="isInLogin && !isPwdRecov" class="landing-container-buttons right">
    <cowing-core-login [isMobile]="isMobile"></cowing-core-login>
  </div>
  <div *ngIf="isPwdRecov" class="landing-container-buttons right">
    <cowing-core-pwd-recovery
      [token]="token"
      [email]="recoverEmail"
    ></cowing-core-pwd-recovery>
  </div>
  <div class="landing-container-footer">
    <cowing-footer></cowing-footer>
  </div>
</div>
